import { Runtime } from '@hud/portal-dtos/webapp-common.dto';
import { HudIconProps } from '../Icons/HudIcons';

export const runtimeToIcon: { [k in Runtime]: HudIconProps['icon'] } = {
  python: 'languages.python',
  nodejs: 'languages.nodejs',
};
export const runtimeToDisplay: { [k in Runtime]: string } = {
  python: 'Python',
  nodejs: 'Node.js',
};
